import type { ShortVideo } from './useFetchShorts';
import type { ShortVideoProperty } from '~/core/entities/property';

/** Card só foto (`includeImagesEvery`): URL vem da galeria mapeada em `images`, não de `thumbnailUrl` do anúncio (ausente sem vídeo). */
function firstImageWatermarkUrl(property: ShortVideoProperty): string | null {
	const url = property.images?.find(img =>
		Boolean(img.watermarkUrl?.trim())
	)?.watermarkUrl;
	return url?.trim() ?? null;
}

export function mapPropertyToShortVideo(
	property: ShortVideoProperty
): ShortVideo | null {
	const short = property.featuredVideos?.[0];
	if (short) {
		return {
			property,
			videoUrl: short.url,
			thumbnailUrl: short.thumbnail ?? property.thumbnailUrl ?? null,
			videoWidth: short.width,
			videoHeight: short.height
		};
	}

	const imageUrl = firstImageWatermarkUrl(property);
	if (!imageUrl) return null;

	return {
		property,
		videoUrl: null,
		thumbnailUrl: imageUrl,
		videoWidth: undefined,
		videoHeight: undefined
	};
}
